<template>
  <div>
    <section-title content="Documentos" :has-line="true" class="mt-5" />
    <custom-callout class="mb-3 custom-callout" :has-toggle="false">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div>
            <label class="color-secondary-6 font-weight-normal mr-2 font-16">
              Nombre del Documento:
            </label>
          </div>
          <p>Informe de Evaluación de Asistencia Tecnológica</p>
        </div>
        <div class="col-12 col-lg-6">
          <div class="d-flex justify-content-lg-end mr-3">
            <action-button
              @click="downloadEvaluationReport"
              variant="success"
              type="button"
              i="fas fa-print"
              class="mt-3"
            >
              Imprimir Evaluación
            </action-button>
          </div>
        </div>
      </div>
    </custom-callout>
    <custom-callout class="mb-3 custom-callout" :has-toggle="false">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div>
            <label class="color-secondary-6 font-weight-normal mr-2 font-16">
              Nombre del Documento:
            </label>
          </div>
          <p>Evaluación de Asistencia Tecnológica (Firmado)</p>
        </div>
        <div class="col-12 col-lg-6">
          <div class="d-flex justify-content-lg-end mr-3">
            <custom-file-input
              id="customInptFileUploadDocumentsPdf"
              ref="documentInputRef"
              accept=".pdf"
              class="file-input__extended mt-3"
              custom-error-msg="El archivo es requerido."
              display-style="normal"
              :on-download="downloadHandler"
              :value="attachment"
              :disabled="fileInputIsDisabled"
              :attachment-id="info.documentId"
              @input="(file) => onUploadFileHandler(file)"
              :name="info.filename"
            />
          </div>
        </div>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomFileInput from 'CustomFileInput';
import reportService from '@/services/api/report.api.js';
import documentService from '@/services/api/document.api.js';
import referralService from '@/services/api/referralsandequipments.api';
import { serialize as objectToFormData } from 'object-to-formdata';
import mixAlert from '@/mixins/alert.mixin';
import peiATServiceStatus from '@/utils/constants/peiATServiceStatus';

export default {
  name: 'TabDocuments',
  components: {
    SectionTitle,
    CustomCallout,
    ActionButton,
    CustomFileInput,
  },
  mixins: [mixAlert],
  props: {
    referralId: {
      type: Number,
      default: () => 0,
    },
    referral: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    attachment: null,
    isEdit: false,
    info: {},
    isDocumentUploaded: false,
    showReplaceDocument: false,
    hasErrorValidation: false,
  }),
  computed: {
    canDelete() {
      return [
        peiATServiceStatus.PendienteDeEvaluacion,
        peiATServiceStatus.PendienteDocumentarEvaluacion,
        peiATServiceStatus.PendienteDeValidacion,
        peiATServiceStatus.PendienteDeAvaluo,
      ].includes(this.referral?.serviceStatusId);
    },
    canReplace() {
      return this.userHasPermissions(
        'technologyassistance.referralmanagment.replacement.signedtechnologicalassistanceevaluationdocument'
      );
    },
    fileInputIsDisabled() {
      return !this.canReplace && !this.canDelete;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const { data } = await referralService.getFileEvaluationInfo(
        this.referralId
      );
      this.info = data;
      this.isEdit = Boolean(data.documentId);
      this.data.documentId = data.documentId;
      if (this.data.onDocumentChange) {
        this.data.onDocumentChange(data.documentId);
      }
      this.isDocumentUploaded = Boolean(data.documentId);
    },
    async deleteHandler() {
      if (this.hasErrorValidation) return;

      this.showReplaceDocument = true;
      this.isEdit = false;
    },
    downloadEvaluationReport() {
      reportService.downloadEvaluationReport(this.referralId);
    },
    async downloadHandler() {
      await documentService
        .downloadatdocument(
          this.info.documentId,
          this.referralId,
          this.info.documentTypeId
        )
        .catch(() => {
          this.ShowToast(
            'Error',
            'Hubo un error al descargar el documento',
            'error'
          );
        });
    },
    async onUploadFileHandler(file) {
      if (!file) {
        return;
      }

      const data = await this.submit(file, this.info.documentId, true);

      if (data) {
        this.ShowToast(
          'Éxito',
          'Se ha guardado el documento correctamente',
          'success'
        );
        this.isDocumentUploaded = true;
        this.showReplaceDocument = false;
      } else {
        const isConfirmed = await this.ShowCancelModal(
          'Confirmación',
          `
          <p>Se identificaron los siguientes hallazgos: <b>el documento anejado no es el correcto o no cuenta con las firmas requeridas.</b></p>
          <p>¿Desea continuar con la subida del documento de  Evaluación de Asistencia tecnológica (Firmado)?</p>
          `,
          'Sí',
          'No'
        );

        if (!isConfirmed) {
          this.hasErrorValidation = true;
          this.$refs.documentInputRef.removeFile();
          return;
        }

        const result = await this.submit(file, this.info.documentId, false);
        if (result) {
          this.ShowToast(
            'Éxito',
            'Se ha guardado la el documento correctamente',
            'success'
          );
          this.isDocumentUploaded = true;
          this.showReplaceDocument = false;
        }
      }

      this.hasErrorValidation = false;
      this.init();
    },
    async submit(file, documentId, validateDocument = false) {
      const payload = {
        file,
        validateDocument,
        documentId,
      };
      const formData = objectToFormData(payload, { indices: true });
      const { data } = await referralService
        .uploadFileEvaluation(this.referralId, formData)
        .catch((error) => {
          this.isEdit = false;
          this.$refs.documentInputRef.removeFile();
          this.ShowToast('Error', error?.response?.data.message, 'error');
        });
      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
.file-input__extended ::v-deep {
  .file-select {
    padding: 0px 37px !important;
  }
}
</style>
